import React, {useMemo} from 'react'

type FileTreeControlContextType = {
  expandAllFolders?: React.MutableRefObject<boolean>
  refreshTree?: React.MutableRefObject<boolean>
  shouldFetchFolders?: React.MutableRefObject<boolean>
}

const FileTreeControlContext = React.createContext<FileTreeControlContextType>({
  expandAllFolders: {} as React.MutableRefObject<boolean>,
  refreshTree: {} as React.MutableRefObject<boolean>,
  shouldFetchFolders: {} as React.MutableRefObject<boolean>,
})

export function FileTreeControlProvider({
  expandAllFolders,
  refreshTree,
  shouldFetchFolders,
  children,
}: React.PropsWithChildren<FileTreeControlContextType>) {
  const value = useMemo(
    () => ({expandAllFolders, refreshTree, shouldFetchFolders}),
    [expandAllFolders, refreshTree, shouldFetchFolders],
  )
  return <FileTreeControlContext.Provider value={value}>{children}</FileTreeControlContext.Provider>
}

export function useFileTreeControlContext() {
  return React.useContext(FileTreeControlContext)
}

try{ FileTreeControlContext.displayName ||= 'FileTreeControlContext' } catch {}
try{ FileTreeControlProvider.displayName ||= 'FileTreeControlProvider' } catch {}